import { gql } from '@apollo/client';

export const CREATE_CATEGORY = gql`
  mutation CreateCategory(
    $name: String!
    $id: ID
    $parentCategoryId: ID
    $childCategories: [String!]
    $color: Color
  ) {
    createCategory(
      name: $name
      id: $id
      parentCategoryId: $parentCategoryId
      childCategories: $childCategories
      color: $color
    ) {
        id
        name
        description
        category {
          id
          name
        }
    }
  }
`;

export const UPDATE_CATEGORY = gql`
    mutation UpdateCategory(
      $id: String!
      $name: String
      $description: String
      $parentCategoryId: ID
      $color: Color
      ) {
        updateCategory(id: $id, data: {
            name: $name
            description: $description
            parentCategoryId: $parentCategoryId
            color: $color
        }) {
          id
          name
          description
          color
          category {
            id
          }
        }
    }
`;

export const REMOVE_CATEGORY = gql`
    mutation RemoveCategory($id: String!) {
        removeCategory(id: $id)
    }
`;
